import { render } from "./TheHeader.vue?vue&type=template&id=872cf46e&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=872cf46e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fpv-raffle/fpv-raffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872cf46e"]])

export default __exports__